import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IAddon, IConcreteBundle, IProduct } from "../../../models/catalogue";
import { IProductID } from "../../../models/nominals";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { getUpgradeID } from "../../configurator/selectors";

type IProps = Immutable<{
    product: IProduct;
    selectedUpgrades: readonly IAddon[];
    isSelected: boolean;
    pageRootProduct: IProductID | null;
    upgradeBundles: readonly IConcreteBundle[];
}> & {
    onSelectionChange: (
        updates: Array<{ productID: IProductID; quantity: number }>,
    ) => void;
};

export const ProductCompareUpgradeTile = ({
    product,
    selectedUpgrades,
    isSelected,
    pageRootProduct,
    onSelectionChange,
    upgradeBundles,
}: IProps): React.ReactNode => {
    const onButtonClick = (
        product: IProduct,
        event: React.MouseEvent<HTMLButtonElement>,
    ) => {
        event.preventDefault();
        const upgradeID = getUpgradeID(product);

        // Select / deselect this product
        const updates = [
            {
                productID: upgradeID,
                quantity: selectedUpgrades.length > 0 ? 0 : 1,
            },
        ];

        // Send change batch
        onSelectionChange(updates);
    };

    const buildUpgradeButton = (bundle: IConcreteBundle) => {
        // #28993 keeps out-of-stock upgrades in the bundle payload so the
        // configurator can grey them out. Compare has no such affordance, so
        // it keeps its previous behaviour of offering nothing.
        return bundle.suggested_products
            .filter((product) => product.availability.is_available_to_buy)
            .map((product) => {
                const buttonText = isSelected
                    ? t`Remove Upgrade`
                    : t`Add Upgrade`;
                return (
                    <button
                        key={`${bundle.id}-${product.id}`}
                        onClick={(event) => onButtonClick(product, event)}
                    >
                        {buttonText}
                    </button>
                );
            });
    };

    const isRootProduct = product.id === pageRootProduct;
    if (!isRootProduct) {
        return null;
    }
    return (
        <>
            {upgradeBundles.map((bundle) => (
                <React.Fragment key={bundle.id}>
                    {buildUpgradeButton(bundle)}
                </React.Fragment>
            ))}
        </>
    );
};
